const config = {
  mainTitle: 'Mascot Additions',
  subHeading: 'A page to see Party Mascot Items. (Note: Price is *100 here)',
  titleIcon: 'IosBookmarksOutline'
}

export default config;
